import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/business/menu_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-88ddb80a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_con" }
const _hoisted_2 = { class: "logo_box" }
const _hoisted_3 = { href: '/' }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "nav_box" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "menu_icon",
  src: _imports_0,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", {
    class: "header_wrapper",
    style: _normalizeStyle({
      background:
        _ctx.route.meta.key == 'index' || _ctx.route.meta.key == 'joinUs'? '#252E4A' : 'rgba(0,0,0,.1)' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _createElementVNode("img", {
            src: require('@/assets/image/common/logo2.png')
          }, null, 8, _hoisted_4)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_menu, {
          selectedKeys: _ctx.current,
          "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.current) = $event)),
          mode: "horizontal",
          class: "a-menu",
          triggerSubMenuAction: _ctx.mobile ? 'click' : ''
        }, _createSlots({
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuData, (item) => {
              return (_openBlock(), _createBlock(_component_a_menu_item, {
                class: "menu-item",
                key: item.key
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: item.url,
                    style: _normalizeStyle({
                color: _ctx.mobile  ? 'rgba(255,255,255,.5)' : _ctx.route.meta.key == 'index' || _ctx.route.meta.key == 'joinUs'? '#fff': '#333333',})
                  }, _toDisplayString(item.name), 13, _hoisted_6)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, [
          (_ctx.mobile)
            ? {
                name: "overflowedIndicator",
                fn: _withCtx(() => [
                  _hoisted_7
                ])
              }
            : undefined
        ]), 1032, ["selectedKeys", "triggerSubMenuAction"])
      ])
    ])
  ], 4))
}